import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-online-training-about',
  templateUrl: './online-training-about.component.html',
  styleUrls: ['./online-training-about.component.scss']
})
export class OnlineTrainingAboutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
